import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RegisterStepsNew from "../../components/UI/RegisterStepsNew/RegisterStepsNew.tsx";
import styles from "./SelectTypeNew.module.scss";
import { ReactComponent as PersonaIcon } from "../../assets/svg/Persona.svg";
import { ReactComponent as EmpresaIcon } from "../../assets/svg/Empresa.svg";
import { connect } from "react-redux";
import { logout } from "../../store/actions";
import { CHANGE_TYPE } from "../../store/actions/types";
import { motion } from "framer-motion";
import { fireAnalytics } from "../../utils/firebase.js";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { getSessionId, getDeviceCategory } from "../../utils/analyticsHelpers.ts";

const variants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1
  }
};

const SelectTypeNew = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Mantener evento antiguo durante transición
    fireAnalytics("ob_step_1", { category: "navigation" });
    
    // Nuevo evento estandarizado
    fireAnalytics("onboarding_step_1_view", {
      category: "onboarding",
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      action: "step_view",
      step: 1
    });

    const storedType = localStorage.getItem("accountTypeNew");
    
    if (storedType) {
      try {
        const parsedType = JSON.parse(storedType);
        props.onChangeHandler(parsedType);
      } catch (error) {
        console.error("Error parsing stored account type:", error);
      }
    }
    
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const actualYear = new Date().getFullYear();

  const handleType = (type) => {
    const backendType = type === "PERSONA" ? "PERSON" : "COMPANY";
    const accountType = backendType; // "PERSON" o "COMPANY"
    
    if (type === "PERSONA") {
      // Mantener evento antiguo durante transición
      fireAnalytics("ob_step_1_profesional", { category: "onboarding" });
      
      // Nuevo evento estandarizado
      fireAnalytics("onboarding_step_1_type_selected", {
        category: "onboarding",
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
        action: "type_selected",
        step: 1,
        account_type: accountType
      });
    } else {
      // Mantener evento antiguo durante transición
      fireAnalytics("ob_step_1_empresa", { category: "onboarding" });
      
      // Nuevo evento estandarizado
      fireAnalytics("onboarding_step_1_type_selected", {
        category: "onboarding",
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
        action: "type_selected",
        step: 1,
        account_type: accountType
      });
    }
    
    localStorage.setItem("accountTypeNew", JSON.stringify(backendType));
    
    navigate("/register-form");
  };

  const select = props.type || "";
  const active = `${styles.typeContainer} ${styles.active}`;
  return (
    <motion.div
      className={styles.container}
      initial="hidden"
      animate={isLoaded ? "visible" : "hidden"}
      variants={variants}
      transition={{
        duration: 0.5,
        ease: "easeOut",
        staggerChildren: 0.1
      }}
    >
      <section className={styles.selectType}>

        <motion.div
          className={styles.selectType_body}
          variants={variants}
        >
          <RegisterStepsNew stepCount={1} />
          <motion.h1
            className={styles.title}
            variants={variants}
          >
            Tipo de cuenta
          </motion.h1>
          <div className={styles.selectType_formContainer}>
            <motion.p
              className={styles.formSubtitle}
              variants={variants}
            >
              Elije que tipo de cuenta se ajusta a tu necesidad
            </motion.p>
            <div className={styles.selectTypeContainer}>
              <motion.div
                layout
                transition={{ ease: "easeInOut", duration: 0.2 }}
                className={`${select === "PERSONA" ? active : styles.typeContainer
                  }`}
                onClick={props.onChangeHandler.bind(this, "PERSONA")}
              >
                <PersonaIcon />
                <div className={styles.buttonType}>Personal</div>
              </motion.div>

              <motion.div
                layout
                transition={{ ease: "easeInOut", duration: 0.2 }}
                className={`${select === "EMPRESA" ? active : styles.typeContainer
                  }`}
                onClick={props.onChangeHandler.bind(this, "EMPRESA")}
              >
                <EmpresaIcon />
                <div className={styles.buttonType}>Empresa</div>
              </motion.div>
            </div>
            <div className={styles.selectTypeContainerButtons}>
              <button
                onClick={() => props.logout(true, navigate)}
                className={`${styles.customButton} ${styles.hover}`}
              >
                <ArrowLeft size={18} />
                <span>Volver</span>
              </button>
              <button
                disabled={select === ""}
                className={`${styles.customButton} ${styles.primaryButton}`}
                onClick={() => handleType(select)}
              >
                <span>Siguiente</span>
                <ArrowRight size={18} />
              </button>

            </div>
          </div>
          <motion.div
            className={styles.copyright}
            variants={variants}
          >
            Copyright © {actualYear} Edify, All rights reserved. Buenos Aires, Argentina.
          </motion.div>
        </motion.div>


      </section>
    </motion.div>
  );
};

const mapStateToProps = (state) => {
  return {
    type: state.register.type,
  };
};

export default connect(mapStateToProps, { onChangeHandler: (tipo) => ({ type: CHANGE_TYPE, payload: tipo }), logout })(SelectTypeNew);
